/**
 * @file Footer.jsx
 * @description Sección de pie de página con enlaces de navegación, lista de platos y redes sociales.
 */

import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Inicio', href: '#' },
    { label: 'Quiénes Somos', href: '#' },
    { label: 'Menú', href: '#' },
    { label: 'Contáctanos', href: '#' },
  ];



  const socialLinks = [
    { label: '/DeliRousRestaurant', icon: <FacebookIcon />, href: 'https://www.facebook.com/DeliRousRestaurant' },
    { label: '/delirousrestaurant', icon: <InstagramIcon />, href: 'https://www.instagram.com/delirousrestaurant' },
  ];

  return (
    <div id="footer">
      <section>
        <Container>
          <Row>
            <Col md={3} xs={5}>
              <h5>Enlaces Rápidos</h5>
              <ul>
                {quickLinks.map(({ label, href }) => (
                  <li key={label}>
                    <h6>
                      <a href={href}>{label}</a>
                    </h6>
                  </li>
                ))}
              </ul>
            </Col>



            <Col md={3} xs={7}>
              <h5>Redes Sociales</h5>
              <ul>
                {socialLinks.map(({ label, icon, href }) => (
                  <li key={label}>
                    <h6>
                      <a href={href} target="_blank" rel="noopener noreferrer">
                        {icon} {label}
                      </a>
                    </h6>
                  </li>
                ))}
              </ul>
            </Col>
          </Row>

          <hr />

          <div className="copyright">
            <p>&copy; {currentYear} DeliRous Restaurant — Lima, Perú. Todos los derechos reservados.</p>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default Footer;
